import React, { memo } from "react";
import moment from "moment";
import LoadingSpinner from "../../LoadingSpinner";
import { BasicTooltip } from "../Tooltip";
import { CopyableId } from "./CopyableId";
import { VersionInfo } from "./VersionInfo";
import { FormatInfo } from "./FormatInfo";
import { ToggleVersions } from "./ToggleVersions";
import { MetaInfoProps } from "./types";

export const MetaInfo: React.FC<MetaInfoProps> = memo(
  ({
    createdAt,
    id,
    versionInfo,
    format,
    showVersions,
    onToggleVersions,
    isLoading,
  }) => {
    return (
      <div className="flex items-center space-x-2">
        {createdAt && (
          <>
            <h4 className="text-sm text-gray-600" title={createdAt}>
              {versionInfo && versionInfo.total > 1
                ? "Last Updated: "
                : "Created: "}
              <BasicTooltip
                content={moment(createdAt).format("MMMM D, YYYY [at] h:mm A")}
              >
                {moment(createdAt).fromNow()}
              </BasicTooltip>
            </h4>
            <div className="h-1 w-1 rounded-full bg-gray-300"></div>
          </>
        )}

        {id !== -1 && <CopyableId id={id} />}
        <VersionInfo versionInfo={versionInfo} />
        <FormatInfo format={format} />
        <ToggleVersions
          showVersions={showVersions}
          onToggleVersions={onToggleVersions}
          versionTotal={versionInfo?.total}
        />
        {isLoading && <LoadingSpinner size={4} />}
      </div>
    );
  },
);
